module.exports = __webpack_public_path__ + "static/media/vegetable_oil.5aae3e0f.jpg";